// backend/src/mw/check.js

import { userGostergeList, rolesUserRoles } from '../Api.svelte';

export async function getAuthorizedData(DataModel) {
    let u_id = localStorage.getItem("uid");
    let userGostergesResponse = await userGostergeList(); // API'den kullanıcı göstergelerini çek
    let userRolesResponse = await rolesUserRoles(u_id); // API'den kullanıcı rollerini çek

    // console.log('check data yanıtı:', DataModel);  // Debug için API yanıtını yazdır
    // console.log('check id yanıtı:', u_id);  // Debug için API yanıtını yazdır
    // console.log('check ug yanıtı:', userGostergesResponse);  // Debug için API yanıtını yazdır
    // console.log('check ur yanıtı:', userRolesResponse);  // Debug için API yanıtını yazdır


    try {
        const userRoles = userRolesResponse;
        // console.log('userRoles:',userRoles);
        // Kullanıcı rolü kontrolü
        const isSuperAdminOrAdmin = userRoles.some(role => ['SUPER_ADMIN', 'Admin'].includes(role));

        if (isSuperAdminOrAdmin) {
            // SUPER_ADMIN veya Admin rolü varsa tüm verileri al
            return DataModel;
        } else {
            // Diğer roller için kullanıcının yetkili olduğu göstergeleri al
            const userGosterges = userGostergesResponse.find(gosterge => gosterge.user_id === u_id);
            if (!userGosterges) {
                throw new Error("No access to any gosterge");
            }
            // console.log('check ugs yanıtı:', userGosterges);  // Debug için API yanıtını yazdır

            const gostergeIds = userGosterges.gosterge_id;
            // console.log('check ugsid yanıtı:', gostergeIds);  // Debug için API yanıtını yazdır
            const filteredDataModel = DataModel.filter(item => gostergeIds.includes(item.gosterge_id));
            // Yetkili olduğu göstergelere göre veri çekme
            // console.log('check son yanıtı:', filteredDataModel);  // Debug için API yanıtını yazdır
            
            return filteredDataModel;
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function getGostergeData(DataModel) {
    let u_id = localStorage.getItem("uid");
    let userGostergesResponse = await userGostergeList(); // API'den kullanıcı göstergelerini çek
    let userRolesResponse = await rolesUserRoles(u_id); // API'den kullanıcı rollerini çek

    // console.log('check data yanıtı:', DataModel);  // Debug için API yanıtını yazdır
    // console.log('check id yanıtı:', u_id);  // Debug için API yanıtını yazdır
    // console.log('check ug yanıtı:', userGostergesResponse);  // Debug için API yanıtını yazdır
    // console.log('check ur yanıtı:', userRolesResponse);  // Debug için API yanıtını yazdır


    try {
        const userRoles = userRolesResponse;
        // Kullanıcı rolü kontrolü
        const isSuperAdminOrAdmin = userRoles.some(role => ['SUPER_ADMIN', 'Admin'].includes(role));

        if (isSuperAdminOrAdmin) {
            // SUPER_ADMIN veya Admin rolü varsa tüm verileri al
            return DataModel;
        } else {
            // Diğer roller için kullanıcının yetkili olduğu göstergeleri al
            const userGosterges = userGostergesResponse.find(gosterge => gosterge.user_id === u_id);
            if (!userGosterges) {
                throw new Error("No access to any gosterge");
            }
            // console.log('check ugs yanıtı:', userGosterges);  // Debug için API yanıtını yazdır

            const gostergeIds = userGosterges.gosterge_id;
            // console.log('check ugsid yanıtı:', gostergeIds);  // Debug için API yanıtını yazdır
            const filteredGDataModel = DataModel.filter(item => gostergeIds.includes(item._id));
            // Yetkili olduğu göstergelere göre veri çekme
            // console.log('check son yanıtı:', filteredGDataModel);  // Debug için API yanıtını yazdır
            
            return filteredGDataModel;
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}
